export const iconFontAwesomeShoppingShopSlash = (
	<i className="fa-solid fa-shop-slash"></i>
);
